<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
      <template #action>
        <div class="main">
          <div class="mb-1 font-bold text-center text-gray-700">ハンコ表集計結果（毎年1月31日までの結果）</div>
          <div class="mb-1 font-bold text-center text-gray-700">※6グループ以下を表示</div>
          <div class="flex">
            <!-- 清算日 -->
            <input
              type="number"
              min="2025"
              max="2100"
              step="1"
              v-model="year"
              class="py-2 border border-gray-400 rounded-md leading-5 focus:bg-white focus:text-gray-900 font-bold w-28 text-center"
              :class="!year?'bg-red-200':''"
            />
            <div class="self-center ml-3">年 2月 に支給</div>

            <div class="font-bold ml-3 self-center text-indigo-700">
              {{ list.length }} 人
            </div>

            <!-- 検索 -->
            <PrimaryButton text="検索" @click="getData()" :buttonContents="'要'" class="ml-5 mr-3">
            </PrimaryButton>

            <!-- CSV -->
            <vue-json-to-csv :json-data="csvData" :csv-title="'ハンコ表支給額_' + year + '年2月'" class="ml-auto mr-1">
              <PrimaryButton text="CSV出力" :buttonContents="'要'" class="bg-yellow-600">
                <Icon v-if="!loading" slot="before" iconName="Download" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                <LoadingIcon v-else slot="before" class="h-4 w-4 my-auto ml-2 text-white" />
              </PrimaryButton>
            </vue-json-to-csv>
          </div>

          <!-- 支給対象者と支給金額 -->
          <div v-if="list&&list.length">
            <table class="text-sm w-full mt-3">
              <thead class="sticky top-0 z-20 bg-colu whitespace-nowrap">
                <tr>
                  <th v-for="(c, i) in columns" :key="'col'+i" class="p-2" :class="c.class">
                    {{ c.val }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in list" :key="'lit'+i" class="border-b hover-color whitespace-nowrap">
                  <!-- 名前 -->
                  <td class="whitespace-pre-line p-2 font-bold">
                    {{ row.userName }}
                  </td>

                  <!-- 件数 -->
                  <td class="whitespace-pre-line p-2 text-center">
                    {{ row.point }}
                  </td>

                  <!-- 金額 -->
                  <td class="whitespace-pre-line p-2 font-bold text-right">
                    {{ Number(row.price).toLocaleString() }} 円
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else-if="!loading" class="flex justify-center items-center text-gray-400 font-bold h-28">
            <p v-if="notCount">集計前です</p>
            <p v-else>対象データがありません</p>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>

import Modal from '@components/Modal.vue'
import Icon from '@components/Icon.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import VueJsonToCsv from 'vue-json-to-csv'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as moment from 'moment'

export default {
  components: {
    Icon,
    Modal,
    PrimaryButton,
    LoadingIcon,
    VueJsonToCsv
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    bonusYear: {
      default: null
    },
  },

  data() {
    return {
      loading: false,
      // 清算月
      year: Number(moment().format('MMMM')),
      // カラム
      columns: [
        { val: '名前', class: 'text-left' },
        { val: '件数' },
        { val: '金額', class: 'text-right' },
      ],
      // リスト
      list: [],
      // 未集計の場合
      notCount: null
    }
  },

  computed: {
    csvData() {
      const res = []
      if (this.list && this.list.length) {
        for (let i = 0; i < this.list.length; i++) {
          const row = this.list[i]
          res.push({
            '': row.userName,
            EBAS001: row.userNum, // 社員番号（給与奉行）
            BPPM020: row.price
          })
        }
      }
      return res
    }
  },

  watch: {
    open() {
      if (this.open) {
        if (this.bonusYear) {
          this.year = Number(this.bonusYear) + 1
        }
        this.getData()
      }
    },
  },

  methods: {
    async getData() {
      if (!this.year) {
        await dialogs.showErrorDialog('「年」 未入力', '「年」を入力してください。')
        return
      }

      this.loading = true
      this.notCount = null

      const res = await backend.searchData('evaluation/stampBonus', { year: this.year })
      if (res.data.data && res.data.data.length) {
        this.list = res.data.data
      } else {
        this.list = []

        const today = moment().format('YYYY-MM')
        const tar = this.year + '-02'
        if (today < tar) {
          this.notCount = true
        }
      }
      this.loading = false
    },

    /**
     * 初期化
     */
    closed() {
      this.$emit('close')
    },
  }
}
</script>
<style scoped>
.main {
  width: 500px;
  min-height: 200px;
  height: calc(100vh - 100px);
  overflow: auto;
}

.hover-color:hover {
  background: rgb(239, 250, 250);
}

.main-height {
  height: calc(100% - 280px);
}
</style>